import { render, staticRenderFns } from "./ContactTags.vue?vue&type=template&id=71f9fa54&scoped=true&"
import script from "./ContactTags.vue?vue&type=script&lang=js&"
export * from "./ContactTags.vue?vue&type=script&lang=js&"
import style0 from "./ContactTags.vue?vue&type=style&index=0&id=71f9fa54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9fa54",
  null
  
)

export default component.exports